import Button from "../core/Button";
import GameConfig from "../core/data/GameConfig";
import Strings from "../core/data/Strings";
import { GameObject } from "../core/GameObject";
import { CharacterUnlockData } from "../game/MissionsState";
import GameColors from "../GameColors";
import PlayerData from "../PlayerData";
import ShopScene from "../scenes/ShopScene";
import Fonts from "../utils/Fonts";

export class CharacterButton extends GameObject {

	index: number;
	lockedGroup: Phaser.GameObjects.Container;
	onClick: () => void;
	btn: Button;
	selectedIcon: Phaser.GameObjects.Image;

	constructor(scene: ShopScene, index: number, character: CharacterUnlockData, locked: boolean, onClick: () => void) {
		super(scene);
		this.index = index;
		this.onClick = onClick;

		const buttonStr = locked ? `${character.button}Locked` : character.button;
		const btn = this.btn = scene.add.button(0, 0, buttonStr, undefined, this.onClick, undefined);
		btn.clickSoundKey = null;
		this.add(btn);
		this.setSize(btn.width, btn.height);

		this.lockedGroup = scene.add.container();
		this.add(this.lockedGroup);

		const characters = GameConfig.get<CharacterUnlockData[]>("characterUnlocks");
		let missionsToComplete = 0;
		for (const char of characters) {
			missionsToComplete += char.missionsToComplete;
			if (char == character) break;
		}

		const saveData = PlayerData.Instance.saveData;
		let numCompletedMissions = 0;
		for (const key of Object.keys(saveData.completedMissions)) {
			numCompletedMissions += saveData.completedMissions[key];
		}
		const progress = Phaser.Math.Clamp(numCompletedMissions / missionsToComplete, 0, 1);

		this.selectedIcon = this.addImage("charBtnSelected");
		scene.alignIn.BottomLeft(this.selectedIcon, btn, -18, -11);
		this.selectedIcon.setVisible(false);
		//Locked assets
		const lockedBacker = scene.add.image(0, 0, "charLockedBacker");
		this.lockedGroup.add(lockedBacker);
		scene.alignIn.Center(lockedBacker, btn, 0, 104);

		const lock = scene.add.image(0, 0, "charLock");
		this.lockedGroup.add(lock);
		scene.alignIn.TopRight(lock, btn, -45, -75);
		const completeText = scene.add.text(0, 0, Strings.get("CompleteMissions1"), {
			fontFamily: Fonts.MaliMediumItalic,
			fontSize: "20px",
			color: GameColors.WHITE,
		});
		this.lockedGroup.add(completeText);
		scene.alignIn.Center(completeText, btn, 0, 40);

		const missionsText = scene.add.text(0, 0, Strings.get("CompleteMissions2").replace("%N", missionsToComplete + ""), {
			fontFamily: Fonts.LuckiestGuy,
			fontSize: "32px",
			color: GameColors.WHITE,
			stroke: GameColors.BLACK,
			strokeThickness: 4,
		});
		this.lockedGroup.add(missionsText);
		scene.alignIn.Center(missionsText, btn, 0, 70);

		const maxWidth = lockedBacker.width - 88;
		const fill = scene.add.nineSlicedSprite(0, 0, "charBtnLockFill", Math.min(maxWidth * progress, maxWidth), 13, 3, 3, 3, 3);
		this.lockedGroup.add(fill);
		scene.alignIn.LeftCenter(fill, lockedBacker, -40, 2);
		fill.setOrigin(0.5, 0.5);
		//fill.rotation = 0.015;
		fill.angle = 0.7;
	}

	updateLayout() {
		let locked = this.index > PlayerData.Instance.saveData.charactersUnlocked;
		if (GameConfig.get<boolean>("allCharactersUnlocked")) locked = false;
		if (!locked && PlayerData.Instance.saveData.currentCharacter != this.index) {
			this.alpha = 0.75;
			this.selectedIcon.setVisible(false);
		}
		else {
			this.alpha = 1;
			if (!locked) this.selectedIcon.setVisible(true);
		}

		this.lockedGroup.visible = locked;
	}

}